import { render, staticRenderFns } from "./orgCreate.vue?vue&type=template&id=4e49049e&scoped=true"
import script from "./orgCreate.vue?vue&type=script&lang=ts"
export * from "./orgCreate.vue?vue&type=script&lang=ts"
import style0 from "./orgCreate.vue?vue&type=style&index=0&id=4e49049e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49049e",
  null
  
)

export default component.exports